import {Children, isValidElement, ReactNode} from 'react';
import {DialogBottomCombinationType} from './DialogBottomCombination';
import {DialogButtonType} from './DialogButton';
import {DialogCheckType} from './DialogCheck';
import {DialogCheckListItemType} from './DialogCheckListItem';
import {DialogDimmedType} from './DialogDimmed';
import {DialogDividerType} from './DialogDivider';
import {DialogImageType} from './DialogImage';
import {DialogLabelType} from './DialogLabel';
import {DialogListType} from './DialogList';
import {DialogOptionType} from './DialogOption';
import {DialogRadioType} from './DialogRadio';
import {DialogStarType} from './DialogStar';
import {DialogTicketCountControlType} from './DialogTicketCountControl';
import {DialogTitleType} from './DialogTitle';
import {DialogViewerSettingType} from './DialogViewerSetting';

const DIALOG_CONTENT_TYPE = [
  DialogLabelType,
  DialogStarType,
  DialogOptionType,
  DialogCheckType,
  DialogCheckListItemType,
  DialogButtonType,
  DialogDividerType,
  DialogTicketCountControlType,
  DialogListType,
  DialogRadioType,
  DialogViewerSettingType,
];

export function getDialogDimmed(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.find(
    child => isValidElement(child) && child.type === DialogDimmedType
  );
}

export function getDialogTitle(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.find(
    child => isValidElement(child) && child.type === DialogTitleType
  );
}

export function getDialogImage(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.find(
    child => isValidElement(child) && child.type === DialogImageType
  );
}

export function getDialogContents(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.filter(
    child => isValidElement(child) && DIALOG_CONTENT_TYPE.includes(child.type)
  );
}

export function getDialogBottomCombination(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.find(
    child => isValidElement(child) && child.type === DialogBottomCombinationType
  );
}
